// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./public/components/EmbedFrame.css
// module id = 587
// module chunks = 3 4 5